import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faSpinner, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { useSearchParams } from 'react-router-dom';
import request from '../../../../../request';
import './WebBooking.css';

/**
 * AppointmentValidation - Handles turn validation via email link
 */
const AppointmentValidation = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('');

    const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/';

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('Token de validación no encontrado.');
            return;
        }

        request.Get(API_BASE + 'web/validate-appointment', { token }, r => {
            if (r.success) {
                setStatus('success');
            } else {
                setStatus('error');
                setMessage(r.msg || 'Error al validar el turno.');
            }
        });
    }, [token]);

    return (
        <div className="web-booking-container">
            <div className="booking-glass-panel p-5 text-center">
                {status === 'loading' && (
                    <div className="py-5">
                        <FontAwesomeIcon icon={faSpinner} spin size="4x" className="text-primary mb-4" />
                        <h3 className="text-white">Validando tu turno...</h3>
                        <p className="text-muted">Por favor espera un momento.</p>
                    </div>
                )}

                {status === 'success' && (
                    <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}>
                        <FontAwesomeIcon icon={faCheckCircle} size="5x" className="text-success mb-4" />
                        <h2 className="text-white font-weight-bold mb-3">¡Turno Confirmado!</h2>
                        <p className="text-muted mb-4 px-3">
                            Tu identidad ha sido validada exitosamente. Tu lugar en la agenda ya está reservado.
                        </p>
                        <div className="bg-glass-dark p-3 border-radius-12 mb-4 d-flex align-items-center justify-content-center gap-3">
                            <FontAwesomeIcon icon={faCalendarAlt} className="text-primary" />
                            <span className="text-white small">Te esperamos en la fecha y hora seleccionada.</span>
                        </div>
                        <button className="auth-btn-primary" onClick={() => window.location.href = '/'}>
                            Finalizar
                        </button>
                    </motion.div>
                )}

                {status === 'error' && (
                    <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}>
                        <FontAwesomeIcon icon={faExclamationCircle} size="5x" className="text-danger mb-4" />
                        <h2 className="text-white font-weight-bold mb-3">Error de Validación</h2>
                        <p className="text-danger mb-4 px-3">{message}</p>
                        <button className="turnero-btn-glass px-4" onClick={() => window.location.href = '/'}>
                            Volver al inicio
                        </button>
                    </motion.div>
                )}
            </div>
        </div>
    );
};

export default AppointmentValidation;
